import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function DyPIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M5.48246 3.5484L1.00739 6.09771V8.64611L5.48246 11.1954L9.95753 8.64611V3.5484L5.48246 1V3.5484Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M14.4326 11.1954L9.95753 8.64611V3.5484L14.4326 6.09771L18.9086 3.5484V11.1954L14.4326 13.7438V11.1954Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M9.95753 13.7438L14.4326 11.1954V13.7438L9.95753 16.2931V13.7438Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M14.4326 6.09771L18.9086 3.5484V11.1954L14.4326 13.7438V6.09771Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M1 6.13778L5.48246 8.66705"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.48246 8.64611L9.95753 6.09771V8.64611L5.48246 11.1954V8.64611Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.48246 1V3.5484L9.95753 6.09771V3.5484L5.48246 1Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M9.95753 16.2931L14.4326 13.7438V11.1954L9.95753 8.64611L5.48246 11.1954V16.2931L9.95753 18.8415V16.2931Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.48246 11.1954L9.95753 13.7438V18.8415L5.48246 16.2931V11.1954Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M9.95845 13.7411L14.4335 11.1927V13.7411L9.95845 16.2904V13.7411Z"
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </SvgIcon>
  );
}
